import { gql } from 'apollo-angular';

export const FAVORITE_BUSINESS_BY_USER_INFO_FRAGMENT = gql`
  fragment FavoriteBusinessByUserInfo on FavoriteBusinessByUser {
    business_ref
    user_id
  }
`;